// Packages
import PropTypes from 'prop-types'

// Components
import CouponForm from 'modules/Coupons/components/Form';

// Other
import useApi from 'hooks/useApi';

const CouponEditScreen = ({  itemId, onClose, onSubmit }) => {

    const { data: item, put: updateItem, errors } = useApi('/coupons/' + itemId + '?with=placements');

	const submit = async (values) => {

        if( await updateItem(values, 'Coupon updated!')) {

            onSubmit();
        }
    }

    return(
        <CouponForm 
            errors={errors} 
            item={item} 
            onClose={onClose} 
            onSubmit={submit} 
            type='edit' 
        />
    )
}

CouponEditScreen.propTypes = {
    itemId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	onClose: PropTypes.func,
    onSubmit: PropTypes.func,
}

CouponEditScreen.defaultProps = {
    itemId: null,
	onClose: () => {alert('onClose is not set!')},
    onSubmit: () => {alert('onSubmit is not set!')}
}

export default CouponEditScreen;